import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from '../modals/DefaultModal';

function ContaModal({ show, onClose, conta, onSaveSuccess }) {
  const [form, setForm] = useState({
    cnpjAssociacao: '',
    numConta: '',
    idBanco: '',
    agencia: '',
    descricao: '',
  });
  const [bancos, setBancos] = useState([]);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const [isSaving, setIsSaving] = useState(false);
  const [modalData, setModalData] = useState({
    show: false,
    type: '',
    message: '',
  });

  useEffect(() => {
    if (conta) {
      setForm({
        cnpjAssociacao: conta.cnpjAssociacao || cnpj,
        numConta: conta.numConta || '',
        idBanco: conta.idBanco || '',
        agencia: conta.agencia || '',
        descricao: conta.descricao || '',
      });
    } else {
      setForm({
        cnpjAssociacao: cnpj,
        numConta: '',
        idBanco: '',
        agencia: '',
        descricao: '',
      });
    }
    // Buscar bancos
    if (!token) {
      console.warn('Token não disponível para carregar dados');
      return;
    }

    const fetchData = async () => {
      try {
        const axios = (await import('axios')).default;
        const bancosRes = await axios.get(`${API_BASE_URL.BANCO}/all`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBancos(Array.isArray(bancosRes.data) ? bancosRes.data : []);
      } catch (error) {
        console.error('Erro ao carregar bancos:', error);
        setBancos([]);
      }
    };
    fetchData();
  }, [conta, show, token, cnpj]);

  const handleChange = e => {
    const { name, value } = e.target;
    
    let newValue = value;
    
    if (name === 'descricao') {
      newValue = value.toUpperCase();
    } else if (name === 'numConta' || name === 'agencia') {
      // Trim de espaços para esses campos
      newValue = value.trim();
    }
    // idBanco permanece como string (001, 033, etc)
    
    setForm(prev => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    
    // Validações - trim() para remover espaços em branco
    if (!form.numConta || !form.numConta.trim()) {
      setModalData({
        show: true,
        type: 'error',
        message: 'Por favor, informe o número da conta.',
      });
      return;
    }

    if (!form.idBanco || form.idBanco === '') {
      setModalData({
        show: true,
        type: 'error',
        message: 'Por favor, selecione um banco.',
      });
      return;
    }

    if (!form.agencia || !form.agencia.trim()) {
      setModalData({
        show: true,
        type: 'error',
        message: 'Por favor, informe a agência.',
      });
      return;
    }

    if (!form.descricao || !form.descricao.trim()) {
      setModalData({
        show: true,
        type: 'error',
        message: 'Por favor, informe a descrição.',
      });
      return;
    }

    setIsSaving(true);
    try {
      // Se conta já existe, PUT, senão POST
      const method = conta ? 'put' : 'post';
      const url = conta
        ? `${API_BASE_URL.CONTA}/update`
        : `${API_BASE_URL.CONTA}/create`;
      const payload = {
        cnpjAssociacao: form.cnpjAssociacao,
        numConta: form.numConta,
        idBanco: form.idBanco,
        agencia: form.agencia,
        descricao: form.descricao,
      };
      
      const token = localStorage.getItem('token');
      const axios = (await import('axios')).default;
      const response = await axios[method](url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200 || response.status === 201) {
        setModalData({
          show: true,
          type: 'success',
          message: 'Conta salva com sucesso!',
        });
        if (onSaveSuccess) onSaveSuccess(response.data);
      } else {
        setModalData({
          show: true,
          type: 'error',
          message: 'Erro ao salvar conta.',
        });
      }
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar conta.';
      setModalData({
        show: true,
        type: 'error',
        message: msg,
      });
    } finally {
      setIsSaving(false);
    }
  };

  const closeDefaultModal = () => {
    setModalData(prev => ({ ...prev, show: false }));
    if (modalData.type === 'success') {
      onClose();
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: 'block' }}
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog"
        role="document"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-content">
          <div
            className="modal-header bg-primary text-white"
            style={{ height: '30px' }}
          >
            <h5 className="modal-title">
              {conta ? 'EDITAR CONTA' : 'NOVA CONTA'}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Conta</label>
                  <input
                    type="text"
                    className="form-control"
                    name="numConta"
                    value={form.numConta}
                    onChange={handleChange}
                    required
                    maxLength={15}
                    disabled={!!conta}
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Agência</label>
                  <input
                    type="text"
                    className="form-control"
                    name="agencia"
                    value={form.agencia}
                    onChange={handleChange}
                    maxLength={10}
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <label className="form-label">Banco</label>
                <select
                  className="form-control"
                  name="idBanco"
                  value={form.idBanco}
                  onChange={handleChange}
                  required
                  style={{ textTransform: 'uppercase' }}
                >
                  <option value="">Selecione...</option>
                  {bancos && bancos.length > 0 ? (
                    bancos.map(b => (
                      <option key={b.id} value={b.id}>
                        {b.id} - {b.nome}
                      </option>
                    ))
                  ) : (
                    <option disabled>Nenhum banco disponível</option>
                  )}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Descrição</label>
                <textarea
                  className="form-control"
                  name="descricao"
                  value={form.descricao}
                  onChange={handleChange}
                  rows={2}
                  maxLength={255}
                  style={{ textTransform: 'uppercase' }}
                  required
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={isSaving}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSaving}
              >
                {isSaving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <DefaultModal
        show={modalData.show}
        type={modalData.type}
        onClose={closeDefaultModal}
        message={modalData.message}
      />
    </div>
  );
}

export default ContaModal;
